import React from 'react';

function Contact() {
  return (
    <section id="contact" className="py-16 bg-gray-100">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-8 text-blue-900">Contact Us</h2>
        <div className="text-center text-gray-700 space-y-4">
          <p>Email: <a href="mailto:info@eclipsecommunications.com" className="text-blue-900 hover:underline">info@eclipsecommunications.com</a></p>
        </div>
      </div>
    </section>
  );
}

export default Contact;